import { LOCALES } from 'i18n/locales';

export const navbarIntl = {
    [LOCALES.ENGLISH]: {
        navbar: 'Navbar',
        'navbar.ariaLabel': 'Navigation links',

        'navbar.logo': 'Navbar logo',
        'navbar.logo.link.ariaLabel': 'GOV.UK NUAR',

        'navbar.links': 'Navigation links',
        'navbar.links.ariaLabel': 'National Underground Asset Register',

        'navbar.account.desktop': 'Desktop Account links',
        'navbar.account.desktop.ariaLabel': 'Account links',

        'navbar.account.dropdown.button': 'Account Menu Button',
        'navbar.account.dropdown.button.ariaLabel': 'Account Menu Button',

        'navbar.account.dropdown.menu': 'Account Menu',
        'navbar.account.dropdown.menu.ariaLabel': 'Account Navigation Menu',

        'navbar.menu': 'Navigation Menu',
        'navbar.menu.ariaLabel': 'Navigation Menu Button',

        'navbar.menu.button': 'Menu',

        'navbar.close.button': 'Close Navigation Menu Button',
        'navbar.close.button.ariaLabel': 'Close Navigation Menu Button',

        'navbar.link.home': 'Home',
        'navbar.link.map': 'Map',
        'navbar.link.bookmark': 'Bookmarks',
        'navbar.link.workpacks': 'Downloads',
        'navbar.link.observation': 'Observations',
        'navbar.link.network.coverage': 'Coverage',

        'navbar.link.platformNotices': 'Upcoming downtime',

        'navbar.link.listI2dPage': 'Enquiries',
        'navbar.link.listEnquiryPage': 'Enquiries',

        'navbar.link.selectLocale': 'CY',
        'navbar.link.selectLocale.ariaLabel.en': 'English (language)',
        'navbar.link.selectLocale.ariaLabel.cy': 'Cymraeg (iaith)',

        'navbar.link.signin': 'Sign in',
        'navbar.link.logout': 'Sign out',

        'footer.link.privacy': 'Privacy',
        'footer.link.cookies': 'Cookies',
        'footer.link.selectLocale': 'Cymraeg', // Needs to be in Welsh NOT English
        'footer.link.selectLocale.ariaLabel': 'Cymraeg (iaith)', // Needs to be in Welsh NOT English

        'navbar.signOut.dialog': 'Confirm Logout Dialog',
        'navbar.signOut.dialog.ariaLabel': 'Confirm Logout Dialog',
        'navbar.signOut.dialog.message': 'Are you sure you want to sign out?',

        'navbar.signOut.dialog.button.agree': 'Confirm Logout ',
        'navbar.signOut.dialog.button.agree.ariaLabel': 'Confirm Logout Button',

        'navbar.signOut.dialog.button.disagree': 'Cancel Logout ',
        'navbar.signOut.dialog.button.disagree.ariaLabel': 'Cancel Logout Button'
    },
    [LOCALES.WELSH]: {
        navbar: 'Navbar',
        'navbar.ariaLabel': 'Dolenni llywio',

        'navbar.logo': 'Navbar logo',
        'navbar.logo.link.ariaLabel': 'GOV.UK NUAR',

        'navbar.links': 'Dolenni llywio',
        'navbar.links.ariaLabel': 'Cofrestr Asedau Tanddaearol Cenedlaethol',

        'navbar.account.desktop': 'Dolenni Cyfrif Bwrdd Gwaith',
        'navbar.account.desktop.ariaLabel': 'Dolenni cyfrif',

        'navbar.account.dropdown.button': 'Botwm Dewislen Cyfrif',
        'navbar.account.dropdown.button.ariaLabel': 'Botwm Dewislen Cyfrif',

        'navbar.account.dropdown.menu': 'Dewislen Cyfrif',
        'navbar.account.dropdown.menu.ariaLabel': 'Dewislen Llywio Cyfrif',

        'navbar.menu': 'Dewislen Llywio',
        'navbar.menu.ariaLabel': 'Botwm Dewislen Llywio',

        'navbar.menu.button': 'Dewislen',

        'navbar.close.button': 'Cau Botwm Dewislen Llywio',
        'navbar.close.button.ariaLabel': 'Cau Botwm Dewislen Llywio',

        'navbar.link.home': 'Hafan',
        'navbar.link.map': 'Map',
        'navbar.link.bookmark': 'Nodau tudalen',
        'navbar.link.workpacks': '[Downloads]',
        'navbar.link.network.coverage': 'Cwmpas',
        'navbar.link.observation': 'Arsylwadau',

        'navbar.link.platformNotices': '[Upcoming downtime]',

        'navbar.link.listI2dPage': 'Ymholiadau',
        'navbar.link.listEnquiryPage': 'Ymholiadau',

        'navbar.link.selectLocale': 'EN',
        'navbar.link.selectLocale.ariaLabel.en': 'English (language)', // Needs to be in English
        'navbar.link.selectLocale.ariaLabel.cy': 'Cymraeg (iaith)',

        'navbar.link.signin': 'Mewngofnodi',
        'navbar.link.logout': 'Allgofnodi',

        'footer.link.privacy': 'Preifatrwydd',
        'footer.link.cookies': 'Cwcis',
        'footer.link.selectLocale': 'English', // Needs to be in English
        'footer.link.selectLocale.ariaLabel': 'English (language)', // Needs to be in English

        'navbar.signOut.dialog': 'Cadarnhau Dialog Allgofnodi',
        'navbar.signOut.dialog.ariaLabel': 'Cadarnhau Dialog Allgofnodi',
        'navbar.signOut.dialog.message': 'Ydych chi\'n siŵr fod eisiau allgofnodi arnoch chi?',

        'navbar.signOut.dialog.button.agree': 'Cadarnhau Allgofnodi ',
        'navbar.signOut.dialog.button.agree.ariaLabel': 'Botwm Cadarnhau Allgofnodi',

        'navbar.signOut.dialog.button.disagree': 'Canslo Allgofnodi ',
        'navbar.signOut.dialog.button.disagree.ariaLabel': 'Botwm Canslo Allgofnodi'
    }
};
